import React, { useMemo, useContext } from "react";

import { TransactionCard, CardInfoType } from "./FinancialCards";

import FinancialContext from "./FinancialContext";

import { TransactionType } from "./FiMaTypes";
import useAxios from "../../services/useAxios";

interface TransactionListProps {
  transactions?: TransactionType[];
}

const TransactionList: React.FC<TransactionListProps> = ({
  transactions: customerTransactions,
}) => {
  // context data
  const { transactions: allTransactions, suspendTransaction } =
    useContext(FinancialContext);

  const transactions = useMemo(
    () => customerTransactions || allTransactions,
    [customerTransactions, allTransactions]
  );

  const theData: {
    id: number;
    status: number;
    info: TransactionType;
    cardInfo: CardInfoType;
  }[] = useMemo(() => {
    return transactions.map((data, i) => ({
      id: data.id,
      status: data.status,
      info: data,
      cardInfo: [
        {
          label: "تاریخ پرداخت",
          value: data.payDate,
        },
        {
          label: "زمان پرداخت",
          value: data.payTime,
        },
        {
          label: "نوع پرداخت",
          value: +data.payType === 1 ? "خروجی" : "ورودی",
        },
        {
          label: "نام بانک",
          value: data.bankName,
        },
        {
          label: "شماره حساب",
          value: data.accountNumber,
        },
      ],
    }));
  }, [transactions]);

  return (
    <>
      {theData.map((data) => (
        <TransactionCard
          key={`transaction-card-${data.id}`}
          id={data.id}
          info={data.cardInfo}
          isSuspension={+data.status === -1}
          suspensionCallback={() => suspendTransaction(data.id, data.info.uid)}
        />
      ))}
    </>
  );
};

export default TransactionList;
